import { inject, Injectable } from '@angular/core';
import { AnalyticsBrowser, UserTraits } from '@customerio/cdp-analytics-browser';
import { environment } from '../../environments/environment';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomerIOService {
  private router = inject(Router);

  private analytics: AnalyticsBrowser;

  init() {
    this.analytics = AnalyticsBrowser.load(
      { writeKey: environment.customerIOKey },
      {
        integrations: {
          'Customer.io In-App Plugin': {
            siteId: environment.customerIOSiteId,
          },
        },
      },
    );

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((page) => {
      this.analytics?.page('Panoptyc App', page.url, {
        context: {
          page: {
            url: page.url,
          },
        },
      });
    });
  }

  async identifyUser(id: string, traits: UserTraits) {
    this.analytics?.identify(id, traits);
  }

  resetUser() {
    this.analytics?.reset();
  }
}
